/* Component Dependencies */
var imageTextCtaCarouselTemplate = require('templates/imageTextCtaCarousel.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
AriesComponent.create({
  type: 'imageTextCtaCarousel',
  template: {
    'imageTextCtaCarousel': imageTextCtaCarouselTemplate
  },
  events: {
    'click .m-image-text-cta-carousel button': 'updateImageText'
  },
  updateImageText: function(elm) {
    var _self = this;
    //console.log(elm);
    _self.leftArrow = _self.$el.find('.m-text-container-carousel button.slick-prev');
    _self.rightArrow = _self.$el.find('.m-text-container-carousel button.slick-next');
   if($(elm.target).hasClass('slick-next')){
      _self.rightArrow.click();
   }
   else{
      _self.leftArrow.click();
   }
    
  }
});
